<template>
  <div class="listContent">
    <a-form :form="form" class="headForm" labelAlign="left">
      <a-row :gutter="24">
        <!-- 基础信息 -->
        <a-col :span="2">
          <a-form-item label="基础信息：">
            <div class="form-text-info"></div>
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item label="动物类型">
            <animal-select style="width: 100%" v-decorator="['animalTypeCode']" />
            <!-- , { rules: [{ required: true, message: '请选择动物类型' }] } -->
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item
            label="线路"
          >
            <a-select allowClear v-decorator="['lineId', { rules: [{ required: false, message: '选择线路' }] }]" placeholder="选择线路">
              <a-select-option v-for="el in lineList" :key="el.id" :value="el.id">
                {{el.name}}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item label="配方类型">
            <a-select size="small" placeholder="全部配方" v-decorator="['formulaType']" style="width: 100%">
              <a-select-option v-for="i in [{name:'全部配方',value: '0'},{name:'配合饲料',value: '1'},{name:'混合日粮',value: '2'}]" :key="i.value">
                {{ i.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item label="配方分类">
            <a-select allowClear v-decorator="['typeClassify']" style="width: 100%" placeholder="配方分类">
           <a-select-option :value="0"> 未分类 </a-select-option>
            <a-select-option :value="1"> 自产配方 </a-select-option>
            <a-select-option :value="2"> 代工配方 </a-select-option>
            <a-select-option :value="3"> 定制配方 </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <!-- 配方相关 -->
        <a-col :span="2">
          <a-form-item label='配方相关：'>
            <div class="form-text-info"></div>
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item label="配方">
            <a-input style="width: 100%" @pressEnter="getListHandle" v-decorator="['formulaName']" placeholder="请输入配方名称或代码" />
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item label="指标" style="height: 40px;">
            <a-select
              allowClear
              show-search
              placeholder="请输入指标名称或代码"
              style="width: 100%;overflow: auto;margin-top: 9px;height: 24px;"
              size='small'
              :default-active-first-option="false"
              :filter-option="false"
              :not-found-content="null"
              @search="getSearchList"
              @select="onSelect"
              v-decorator="['nutritionIds']"
              @inputKeydown='inputKeydown'
              :showArrow="true"
            >
              <a-select-option v-for="d in searchList" :key="d.id">
                {{d.firstName}}<span style="color: red">{{d.midName}}</span>{{d.lastName}}({{d.code}})
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="7">
          <a-form-item label="编辑日期">
            <a-range-picker v-decorator="['editDateRange']" style="width: 100%" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <!-- 组织架构 -->
        <a-col :span="2">
          <a-form-item label="组织架构：">
            <div class="form-text-info"></div>
          </a-form-item>
        </a-col>
        <a-col :span="7">
          <a-form-item label="工厂">
            <a-select
              placeholder="请选择工厂"
              size='small'
              v-decorator="['factoryIds']"
              mode="multiple"
              :max-tag-count="1"
              :showArrow="true"
            >
              <a-select-option v-for="i in factoryList" :key="i.factoryId">
                {{ i.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <!-- 操作 -->
        <a-col :span="2">
          <a-form-item>
            <div class="form-text-info"></div>
          </a-form-item>
        </a-col>
        <a-col :span="6" class="submitBtnBox">
          <a-button type="primary" class="btnMar" @click="getListHandle">
            查询
          </a-button>
          <a-button type="primary" class="btnMar" :disabled="selectedRowKeys.length !== 2" @click="analyseModalFunc">
            执行对比
          </a-button>
          <a-button v-if="nExport" :loading="downloading" type="primary" class="btnMar" @click="openExport">
            导出数据
          </a-button>
          <a-button class="" @click="resetFields">
            清空
          </a-button>
        </a-col>
      </a-row>
    </a-form>

    <!-- <div class="editBox">
      <a-button type="primary" @click="analyseModalFunc">
        + 添加
      </a-button>
      <a-button @click="deleteData" type="danger" ghost>
        删除
      </a-button>
    </div> -->
    <!-- :scroll="{y: 500}" -->
    <a-table
      ref="listRef"
      id="table-dom"
      :row-key="record => record.id"
      :columns="columns"
      :loading="loading"
      :data-source="list"
      class="tableBox"
      :pagination="pagination"
      :scroll="{ y, x: 1000 }"
      bordered
      :row-selection="rowSelection"
    >
      <template slot="factoryName" slot-scope="text, record">
        <span style="font-size: 12px">{{ record.factoryName }}</span>
      </template>
      <div slot="typeClassify" slot-scope="text">
        {{ typeObj[text] }}
      </div>
    </a-table>
    <!-- 新增 -->

    <Analyse ref="analyse" class="modalBox" :visible.sync="analyseModal" :ary="ary" :selectedAry="selectedAry"/>

    <!-- 导出 -->
    <ExportConfirm :visible="exportVisible" @close="closeExport" :formData="formData"/>
  </div>
</template>
<script>
import { columns, pagination ,columns2} from './config'
import { TpWatermark } from '../utils'

import * as API from './api'
import Analyse from './components/Analyse.vue'
import AnimalSelect from '../MaterialAnalyse/components/AnimalSelect.vue'
import ExportConfirm from "./components/ExportConfirm.vue";
import moment from "moment/moment";
export default {
  name: 'NutritionAnalyse',
  props: {
    menuBtnList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  components: {
    ExportConfirm,
    AnimalSelect,
    Analyse
  },
  mounted() {
    TpWatermark('table-dom', localStorage.getItem('userName') + ' newhope', '150', '450', '-5', 'grey', '50', '0.06')
    this.y = this.$refs.listRef.$el.offsetHeight - 100
    this.form.setFieldsValue({formulaType: '0'})
    this.getBtn();
  },
  watch: {},
  data() {
    return {
      y: 380,
      typeList: [],
      factoryList: [],
      formData: {},
      selectedAry: [],
      nExport: false,
      exportVisible: false,
      form: this.$form.createForm(this, { name: 'EvalueTool' }),
      // selectedFormulaCode: null,
      confirmLoading: false,
      analyseModal: false, // 是否显示弹窗
      formItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 }
      },
      loading: false,
      downloading: false,
      pagination: {
        ...pagination,
        showSizeChanger: true, // 显示每页条数选择器
        pageSizeOptions: ['10', '20','30','40','50', '100'], // 可选的每页条数
        onChange: (current, size) => {
          this.pagination.current = current
          this.getList({ current, pageSize:size })
        }, //选择页数
        onShowSizeChange: (current, size) => {
          this.pagination.pageSize = size
          this.pagination.current = 1
          this.getList({ current: 1, pageSize:size })
        } //每页多少条
      },
      list: [],
      changedRows: {},
      // columns,
      lineList: [],
      searchList:[],
      columns2,
      noMartial: false,
      ary: [],
      selectedRowKeys: [], // 新增：存储选中的行键
      selectedRows: [], // 新增：存储选中的完整行数据
      typeObj: {
        0: '未分类',
        1: '自产配方',
        2: '代工配方',
        3: '定制配方',
      },
    }
  },
  computed: {
    editColumns() {
      return this.columns.filter(item => item.editable).map(v => v.dataIndex)
    },
    columns(){
      return this.noMartial ? columns : columns2
    },
    rowSelection() { // 修改：定义 rowSelection 配置
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        getCheckboxProps: this.getCheckboxProps
      };
    },
  },
  created() {
    // this.getList()
    this.factoryGet()
    // this.getTypeList()
    this.getTypeList2()
  },
  beforeMount() {
    this.y = window.innerHeight - 400
  },
  methods: {
    getBtn() {
      let factoryId = window.localStorage.getItem('factoryId');
      if (!factoryId) return;
      this.$http.get("/iot-system/menu/buttons", { params: { controlEnd: false, factoryId } }).then(res => {
        let { success, data } = res;
        if (success) {
          data && data.forEach(el => {
            if (el.path === '/fast/NutritionAnalyse') {
              el.children && el.children.forEach(item => {
                if (item.code === 'nExport') this.nExport = true;
              });
            }
          });
        }
      });
    },
    getTypeList2(){
      let params = {
        current: 1,
        size: 10000
      }
      this.$http.get(`/nhf-core-data/line/list`,{params}).then(res => {
        let { success, data } = res
        if (success) {
          let {records} = data || {}
          records&&records.map(el => {
            el.value = el.id
            el.label = el.name
            return
          })
          this.typeList = records || []
          this.getLineList()
        }
      })
    },
    getLineList(){

      let staffId = window.localStorage.getItem('staffId')
      if(!staffId) return
      this.$http.get(`/iot-factory/factorystaffauth/getAnimalIdsInfoByStaffId?StaffId=${staffId}&type=0`).then(data => {
        // let {success,data} = res || {}
        if(data && data.length > 0){
          data = data.sort((a,b) => a - b)
          let lineList = []
          this.typeList && this.typeList.forEach(el => {
            if(data.includes(el.id)) lineList.push(el)
          })
          this.lineList = lineList
          this.animalRootId = data[0]
          // this.form.setFieldsValue({lineId: data[0] || ''})
          // setTimeout(() => {
          //   this.getList()
          // }, 0);
        }
      })
    },
    inputKeydown(e){
      if(e.keyCode === 13) this.getList({current:1,pageSize:20})
    },
    getSearchList(name){
      if(name){
        setTimeout(() => {
          this.placeStr = name || '请输入营养指标名称/代码'
          this.form.setFieldsValue({name})
            this.$get('/nhf-core-data/nutritiontarget/fastNutritionUserPage',{
              current: 1,
              size:100,
              // factoryId: window.localStorage.getItem('factoryId'),
              searchKey:name
              }).then(res => {
              let {success,data} = res;
              if(success){
                let {records} = data || {}
                records.map(el => {
                  // 使用不区分大小写的正则表达式查找匹配项
                  let reg = new RegExp(name, 'i');
                  let match = el.name.match(reg);
                  if (match) {
                    // 获取匹配项在原字符串中的位置
                    let startIndex = match.index;
                    let endIndex = startIndex + match[0].length;

                    // 按位置分割字符串
                    el.firstName = el.name.substring(0, startIndex);
                    el.midName = el.name.substring(startIndex, endIndex); // 保留原始大小写
                    el.lastName = el.name.substring(endIndex);
                  } else {
                    // 无匹配则将整个名称作为 firstName
                    el.firstName = el.name;
                    el.midName = '';
                    el.lastName = '';
                  }
                  return el;
                })
                this.searchList = records || []
              }else{
                this.searchList = []
              }
            }).catch(() => {
              this.searchList = []
            })
        }, 300);
      }
    },
    onSelect(val){
      this.selectedRowKeys = []
      this.getList({pageSize:this.pagination.pageSize,current:1,val})
    },
    hasPermission(code) {
      const codes = []
      const fn = ary => {
        ary.forEach(a => {
          codes.push(a.code)
          if (a.children) {
            fn(a.children)
          }
        })
      }
      fn(this.menuBtnList)
      return codes.includes(code)
    },
    async exportFile() {
      const valid = await this.form.validateFields()
      if (!valid) {
        return false
      }
      this.downloading = true
      let { factoryIds = [], ...newdata } = valid
      await API.exportFile({ ...newdata, factoryIds: factoryIds.join(',') }).catch(e => {
        e.message && this.$message.error(e.message)
      })
      this.downloading = false
    },
    disabledFn(row) {
      const limit = 2
      if (this.selectedRowKeys.map(v => v.id).indexOf(row.id) !== -1) {
        return false
      }
      // if (this.selectedFormulaCode && this.selectedRowKeys.length < limit) {
      //   return row.formulaCode !== this.selectedFormulaCode
      // }
      return this.selectedRowKeys.length >= limit
    },
    checkboxChange(e, row) {
      const { checked } = e.target
      if (checked) {
        this.selectedRowKeys.push(row)
        // this.selectedFormulaCode = row.formulaCode
      } else {
        this.selectedRowKeys = this.selectedRowKeys.filter(v => v.id !== row.id)
        // if (this.selectedRowKeys.length === 0) {
        // this.selectedFormulaCode = null
        // }
      }
    },
    filterOption(inputValue, option) {
      try {
        return option.componentOptions.children[0].text.indexOf(inputValue) >= 0
      } catch (e) {
        return false
      }
    },
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true
      setTimeout(() => {
        targetOption.loading = false
        this.getTypeList(targetOption.id, targetOption) || []
      }, 0)
    },

    resetFields() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
      this.form.setFieldsValue({
        animalTypeCode: undefined,
        formulaName: null,
        nutritionIds: undefined,
        factoryIds: [],
        lineId: undefined,
        formulaType: '0',
        typeClassify: undefined,
        editDateRange: undefined,
      })
    },
    refreshTypeList(data) {
      this.getTypeList(data.id, data.targetOption)
    },
    getListHandle() {
      this.selectedRowKeys = []
      this.pagination.current = 1
      return this.getList(this.pagination)
    },
    async getList(pagination) {
      const valid = await this.form.validateFields()
      if (!valid) {
        return false
      }
      this.loading = true
      let { current = 1, pageSize = 20 } = pagination || this.pagination
      let { factoryIds = [], editDateRange = [], ...newdata } = valid
      let editTimeStart = editDateRange[0] ? moment(editDateRange[0]).format('YYYY-MM-DD 00:00:00') : undefined
      let editTimeEnd = editDateRange[1] ? moment(editDateRange[1]).format('YYYY-MM-DD 23:59:59')  : undefined

      let params = {
        staffId: localStorage.getItem('staffId'),
        factoryIds: factoryIds.join(','),
        editTimeStart,
        editTimeEnd,
        ...newdata,
        requestType: 2,
        current,
        size: pageSize
      }
      let feild = 'nutritionGet2'
      if(newdata.nutritionIds){
        feild = 'nutritionGet'
        // params.nutritionIds = params.nutritionIds.join(',')
        this.noMartial = false
      }
      await API[feild](params)
      // await API.nutritionGet(params)
        .then(res => {
          let { success, data } = res
          if (success) {
            let { records = [], current = 1, total = 0, size = 10 } = data
            this.list = records
            //将lineId映射为名称
            this.list.map(el => {
              let item = this.lineList.find(el2 => el2.id === el.lineId);
              if(item){
                el.lineName = item.name
              }
              return el
            })
            this.pagination.current = current
            this.pagination.total = total
            this.pagination.pageSize = size
          } else {
            this.$message.error('查询失败')
          }
          this.loading = false
        })
        .catch(e => {
          this.loading = false
          e.message && this.$message.error(e.message)
        })
      this.loading = false
    },
    getTypeList(parentId = '0', record, type) {
      this.$http.get(`/nhf-core-data/animal/listByParentId?parentId=${parentId}`).then(res => {
        let { success, data = [] } = res
        if (success) {
          data &&
            data.map(el => {
              el.value = el.id
              el.label = el.name
              el.isLeaf = !el.hasChildren
              // el.isLeaf = false
              return el
            })
          if (record) {
            // data = [
            //   {name: '测试1',id: '测试1',value: '测试1',label: '测试1',isLeaf: '测试1'}
            // ]
            if (data.length) {
              record.children = data
            } else {
              record.isLeaf = true
            }
            if (!type) {
              this.typeList = [...this.typeList]
            } else {
              this.list = [...this.list]
            }

            if(type) {
              this.form.setFieldsValue({lineId: this.typeList[0].children[0].id || ''})
              this.lineList = data
            }
          } else {
            this.typeList = data
          }
          // this.typeList = data
          // return data
        } else {
          this.typeList = []
        }


        // if(type) this.getLineList()
        if(parentId === '0'){
          this.getTypeList(this.typeList[0].id,this.typeList[0],true)
        }
      })
    },
    async factoryGet() {
      // API.factoryGet()
      //   .then(res => {
      //     console.log
      //     let { success, data } = res
      //     if (success) {
      //       this.factoryList = data.records || []
      //     } else {
      //       this.$message.error('获取公司失败')
      //     }
      //   })
      //   .catch(e => {
      //     this.$message.error(e.message)
      //   })

      let params = {
        current: 1,
        size: 100,
      };
      const res = await this.$http.get("/nhf-app/formulaManage/myFactory", { params })
      let { success, data } = res;
      if (success) {
        let { records} = data;
        this.factoryList = records || [];
      }
    },
    // analyseModalFunc() {
    //   // 新增显示或关闭
    //   this.analyseModal = !this.analyseModal
    // }
    async analyseModalFunc() {
      // 新增显示或关闭// 新增显示或关闭
      const valid = await this.form.validateFields()
      let formulaIds = []
      let flag = true
      let requestType = 2
      let {lineId} = valid || {}
      //清除this.selectedAry数据
      this.selectedAry = []
      console.log(this.selectedRowKeys)
      // 修改：使用selectedRows而不是通过ID查找
      this.selectedRows.forEach(row => {
        if (row.nutritionId) flag = false
        formulaIds.push(row.id)
        this.selectedAry.push({
          factoryName: row.factoryName,
          formulaName: row.formulaName,
          formulaCode: row.formulaCode
        })
      });
      if(flag){
        await API.nutritionGet({
          formulaIds:formulaIds.join(','),lineId,requestType,
          current: 1,size: 5000
        }).then(res => {
          let { success, data } = res
          if(success){
            let {records} = data || {}
            this.ary = records || []
            setTimeout(() => {
              this.analyseModal = !this.analyseModal
            }, 0);
          }
        })
      }else{
        // 修改：直接使用selectedRows
        this.ary = this.selectedRows;
        setTimeout(() => {
          this.analyseModal = !this.analyseModal
        }, 0);
      }
    },
    openExport() {
      this.formData = this.form.getFieldsValue();
      //如果营养指标列表为空，则提示导出必须有原料
      // if(this.formData.nutritionIds === undefined){
      //   this.$message.error('导出营养指标列表为空，请先添加营养指标');
      //   return;
      // }
      this.exportVisible = true;
    },
    closeExport() {
      this.exportVisible = false
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      if (selectedRowKeys.length > 2) {
        this.$message.warning('只能选择2行');
        return;
      }
      this.selectedRowKeys = selectedRowKeys;
      // 维护完整的选中行数据
      // 移除已取消选择的行
      this.selectedRows = this.selectedRows.filter(row =>
          selectedRowKeys.includes(row.id)
      );

      // 添加新选择的行（避免重复添加）
      selectedRows.forEach(row => {
        if (!this.selectedRows.some(selectedRow => selectedRow.id === row.id)) {
          this.selectedRows.push(row);
        }
      });
      console.log('选中的完整数据:', this.selectedRows);
    },
    getCheckboxProps(record) {
      return {
        props: {
          disabled: this.selectedRowKeys.length >= 2 && !this.selectedRowKeys.includes(record.id),
        },
      };
    },
  }
}
</script>

<style lang="scss" scoped>
.listContent {
  // height: calc(100% - 36px);
  .tableBox {
    height: calc(100% - 132px);
    min-height: 240px;
  }
}
#table-dom {
  position: relative;
}
::v-deep .ant-table-thead > tr > th {
  padding: 0px;
}
.headForm {
  margin-bottom: 10px;
}
// 新增样式
.form-text-info {
  font-size: 12px;
  display: flex;
  align-items: center; /* 上下居中 */
}
</style>
